import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-6 offset-sm-3" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h1", null, [
  /*#__PURE__*/_createVNode("span", { class: "badge text-dark" }, "Log in to start")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "unprotected"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("h5", null, [
  /*#__PURE__*/_createVNode("span", { class: "badge bg-warning" }, "Login failed, please check your account details...")
], -1)
const _hoisted_7 = {
  key: 1,
  class: "unprotected"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("h5", null, [
  /*#__PURE__*/_createVNode("span", { class: "badge bg-success" }, "Good to go, you're logged in!")
], -1)
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", {
  for: "loginUserInputField",
  class: "form-label"
}, "Username", -1)
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", {
  for: "loginUserPasswordField",
  class: "form-label"
}, "Password", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", {
  id: "passwordHelp",
  class: "form-text"
}, [
  /*#__PURE__*/_createTextVNode("10+ characters, with at least one uppercase (A, B, ...) , one lowercase (a, b, ...), a number (0, 1, ...), and, a symbol ($, !, ...). Something like "),
  /*#__PURE__*/_createVNode("span", { class: "mark" }, "Today is day 1!"),
  /*#__PURE__*/_createTextVNode(" would do.")
], -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "submit",
    class: "btn btn-primary"
  }, "Login")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.loginError)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _hoisted_6
            ]))
          : _createCommentVNode("", true),
        (_ctx.loginStatus)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _hoisted_8
            ]))
          : _createCommentVNode("", true),
        (!_ctx.loginStatus)
          ? (_openBlock(), _createBlock("form", {
              key: 2,
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.callLogin()), ["prevent"]))
            }, [
              _createVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "loginUserInputField",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.user = $event))
                }, null, 512), [
                  [_vModelText, _ctx.user]
                ])
              ]),
              _createVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createVNode("input", {
                  type: "password",
                  class: "form-control",
                  id: "loginUserPasswordField",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.password = $event))
                }, null, 512), [
                  [_vModelText, _ctx.password]
                ]),
                _hoisted_13
              ]),
              _hoisted_14
            ], 32))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}